import {
  Currency, LoanCollectionFee, LoanDelinquency, Installment,
} from '../../../types/account';

export const installmentStateLabels: { [key: string]:string } = {
  ACTIVE: 'ACTIVA',
  SOFT_DEBT: 'MOROSA BLANDA',
  INTERMEDIATE_DEBT: 'MOROSA INTERMEDIA',
  HARD_DEBT: 'MOROSA DURA',
  PAID: 'PAGADA',
  PUNISHED: 'CASTIGADA',
  RECOVERED: 'PAGADA',
};
export const intallmentStateDefinitions: { [key: string]:string } = {
  PAID: 'La cuota ya fue oportunamente cancelada.',
  ACTIVE: 'El pago de la cuota continúa pendiente.',
  SOFT_DEBT: 'Signifca estar atrasado/a en cualquier pago entre 1 y 30 días.',
  INTERMEDIATE_DEBT: 'Signifca estar atrasado/a en cualquier pago entre 30 y 90 días. Se ingresa deuda a DICOM',
  HARD_DEBT: 'Signifca estar atrasado/a en cualquier pago sobre 90 días. Se evalua cobranza judicial.',
  PUNISHED: 'Signifca estar atrasado/a en cualquier pago sobre 180 días. Se inicia una cobranza judicial.',
  RECOVERED: 'Signifca que una cuota que estaba CASTIGADA fue pagada.',
};
export const installmentStateColor = (state: string) => {
  switch (state) {
    case 'PAID':
    case 'RECOVERED':
      return 'green';
    case 'SOFT_DEBT':
      return 'orange';
    case 'INTERMEDIATE_DEBT':
      return 'red';
    case 'HARD_DEBT':
    case 'PUNISHED':
      return 'purple';
    default:
      return undefined;
  }
};

export const userInvoiceInjectionStatusColor = (status: string, state: string) => {
  if (state === 'PAID') {
    return 'green';
  }
  switch (status) {
    case 'PENDING':
      return 'orange';
    case 'SUCCESSFUL':
      return 'green';
    case 'FAILED':
    case 'CANCELED':
      return 'red';
    case 'NONE':
    default:
      return 'gray';
  }
};

export const userInvoiceInjectionStatusLabels: { [key: string]:string } = {
  PENDING: 'EN PROCESO',
  SUCCESSFUL: 'PAGADA',
  FAILED: 'FALLIDA',
  CANCELED: 'FALLIDA',
  NONE: 'PENDIENTE',
};

export function createData(
  period: number,
  expirationDate: string,
  principal: number,
  interest: number,
  amount: number,
  state: string,
  currency: Currency,
  userInvoiceInjectionStatus: Installment['userInvoiceInjectionStatus'],
  delinquencies?: LoanDelinquency,
  collectionFees?: LoanCollectionFee,
) {
  const delinquencyAmount = delinquencies?.amount || 0;
  const collectionFeeAmount = collectionFees?.amount || 0;
  return {
    period,
    expirationDate,
    principal,
    interest,
    amount: amount + delinquencyAmount + collectionFeeAmount,
    state,
    currency,
    delinquencyAmount,
    collectionFeeAmount,
    userInvoiceInjectionStatus,
  };
}

export function mapInstallments(
  installments: Installment[],
  loanDelinquencies: LoanDelinquency[],
  loanCollectionFees: LoanCollectionFee[],
) {
  const dictLoanUnpaidDelinquencies = loanDelinquencies.reduce((acc, delinquency) => {
    acc[delinquency.installmentId] = delinquency;
    return acc;
  }, {} as Record<string, LoanDelinquency>);
  const dictLoanUnpaidCollectionFees = loanCollectionFees.reduce((acc, fee) => {
    acc[fee.installmentId] = fee;
    return acc;
  }, {} as Record<string, LoanCollectionFee>);
  return installments.map((inst) => {
    const unpaidDelinquency = dictLoanUnpaidDelinquencies[inst.id];
    const unpaidCollectionFee = dictLoanUnpaidCollectionFees[inst.id];
    return {
      ...inst,
      unpaidDelinquency,
      unpaidCollectionFee,
    };
  });
}

export const installmentStateExplanations = [
  'ACTIVA: El pago de la cuota continúa pendiente.',
  'PAGADA: La cuota ya fue debidamente cancelada.',
  'MOROSA BLANDA: Signifca estar atrasado/a en cualquier pago entre 1 y 30 días.',
  'MOROSA INTERMEDIA: Signifca estar atrasado/a en cualquier pago entre 30 y 90 días. Se ingresa deuda a DICOM.',
  'MOROSA DURA: Signifca estar atrasado/a en cualquier pago por más de 90 días. Se evalúa cobranza judicial.',
  'CASTIGADA: Signifca estar atrasado/a en cualquier pago por más de 180 días. Se inicia una cobranza judicial.',
  'RECUPERADA: Signifca que una cuota que estaba CASTIGADA fue pagada.',
];

export const injectionStateExplanations = [
  {
    label: 'EN PROCESO:',
    explanation: 'El pago de la cuota se encuentra en proceso de cobro. Solo debes preocuparte de tener el saldo disponible en tu cuenta para que se realice el pago automáticamente.',
  },
  {
    label: 'PAGADA:',
    explanation: 'La cuota ha sido debidamente pagada.',
  },
  {
    label: 'FALLIDA:',
    explanation: 'El pago de la cuota ha fallado, y se reintentará nuevamente a las 00:00 horas.',
  },
  {
    label: 'PENDIENTE:',
    explanation: 'La cuota se encuentra activa, y pendiente de ser enviada a cobrar en la fecha de vencimiento.',
  },
];
